<template>
  <WmsSelectionButton
    v-bind="$attrs"
    :selections="availablePowerFlagSelections"
    :multiSelect="false"
    :value="internalValue"
    @change="onChange"
  />
</template>
<script>
import WmsSelectionButton from '@wmscomponents/WmsSelectionButton.vue'

const availablePowerFlagSelections = [
  {
    value: '有',
    text: '有'
  },
  {
    value: '無',
    text: '無'
  },
  {
    value: '不明',
    text: '不明'
  }
]

export default {
  inheritAttrs: false,

  components: {
    WmsSelectionButton
  },
  
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    internalValue() {
      const value = this.value.map((v) => {
        return this.availablePowerFlagSelections.find((selection) => {
          return selection.value === v
        })
      })
      return value
    }
  },

  data() {
    return {
      availablePowerFlagSelections
    }
  },

  methods: {
    onChange(selectionItems) {
      const value = selectionItems.map((item) => {
        return item.value
      })
      this.$emit('change', value)
    }
  }
}
</script>